import { getUrl, Request } from "../../request";

export const getStocks = (page = null, search = null) => {
  return Request.get(getUrl(`/api/v1/service_center/service-center-stock/`), {
    q: search,
    page,
  });
};
